module.exports = __webpack_public_path__ + "img/summer-1.a605066e.jpg";